import React, { Component } from 'react';
import { TOKEN_INFO, storage } from '../../../app/Storage';
import { decode } from 'jsonwebtoken';

class BusSchedMetadata extends Component {
    render() {
        let customBusSchedGenerator = this.getCustomBusSchedGenerator();
        switch (customBusSchedGenerator) {
            case "VIA PORTO":
                return this.viaPortoGeneratorMetadata();
            case "CARRIS":
                return this.carrisGeneratorMetadata();
            case "TML":
            case "RDL":
                return this.tmlGeneratorMetadata();
            case "SMTUC":
                return this.smtucGeneratorMetadata();
            default:
                return this.nativeGeneratorMetadata();
        }
    }

    getCustomBusSchedGenerator(){
        let customBusSchedGenerator = "";
        let tokenInfo = storage.get(TOKEN_INFO);

        if (typeof tokenInfo !== 'undefined') {
            var json = JSON.parse(tokenInfo);
            tokenInfo = Object.assign({}, json);
        }

        if (tokenInfo.id_token) {
            let idToken = decode(tokenInfo.id_token);
            customBusSchedGenerator = idToken.cbsg_id !== undefined ? idToken.cbsg_id : "";
        }
        return customBusSchedGenerator;
    }

    tmlGeneratorMetadata(){
        return (
            <div>
                <h2> Gerador de Horários </h2>
                <p>
                    Nesta página pode gerar horários utilizando o gerador específico da TML. Os diferentes horários disponíveis são exibidos em formato de tabela.
                    Os horários podem ser mostrados consoante Linha ou Paragem, sendo que no caso da Paragem são apresentadas as várias linhas às quais a mesma pertence.
                </p>
                <h3>Funcionalidades disponíveis</h3>
                <ul className="bulleted-list">
                    <li>Selecionar entre Layout de Linha ou Paragem.</li>
                    <li>Definir a edição a ser utilizada através da Data de Referência.</li>
                    <li>Definir a Data de Referência do documento.</li>
                    <li>Definir a frequência dos horários.</li>
                    <li>Selecionar a Linha ou Paragem sobre a qual os horários serão gerados.</li>
                    <li>Selecionar diferentes horários para geração.</li>
                    <li>Selecionar todos os horários de um dado Período.</li>
                    <li>Editar as definições de um dado Período.</li>
                    <li>Selecionar horários de diferentes linhas para uma dada paragem.</li>
                    <li>Gerar os horários selecionados.</li>
                    <li>Guardar seleções de horários gerados.</li>
                    <li>Gerar seleções prévias.</li>
                    <li>Alterar a ordem dos elementos da lista.</li>
                    <li>Definir linhas não susceptíveis a excepções.</li>
                </ul>
            </div>
        );
    }

    nativeGeneratorMetadata(){
        return(
            <div>
            <h2> Gerador de Horários </h2>
            <p>
                Nesta página pode gerar horários utilizando o gerador nativo. Os diferentes horários disponíveis são exibidos em formato tabela. O utilizador pode
                selecionar qual Layout será utilizado na geração. A opção "Horário de Paragem" permite selecionar quais as paragens de uma dada linha serão geradas.
                A opção "Horário de Linha" gera horários a primeira paragem de cada percurso da Linha.
            </p>
            <h3>Funcionalidades disponíveis</h3>
            <ul className="bulleted-list">
                <li>Selecionar entre Horário de Paragem ou de Linha.</li>
                <li>Escolher a Linha sobre a qual os horários serão gerados.</li>
                <li>Escolher o Layout utilizado para gerar o horário.</li>
                <li>Definir a edição a ser utilizada através da Data de Referência.</li>
                <li>Selecionar as Paragens e os Horários para serem gerados.</li>
                <li>Selecionar todas as Paragens.</li>
                <li>Selecionar todos os Horários.</li>
                <li>Adicionar observações, caso suportadas pelo Layout.</li>
                <li>Gerar os horários selecionados.</li>
            </ul>
        </div>
        )
    }

    viaPortoGeneratorMetadata(){
        return(
            <div>
            <h2> Gerador de Horários </h2>
            <p>
                Em construção.
            </p>
        </div>
        )
    }

    carrisGeneratorMetadata(){
        return(
            <div>
            <h2> Gerador de Horários </h2>
            <p>
                Em construção.
            </p>
        </div>
        )
    }

    smtucGeneratorMetadata(){
        return(
            <div>
            <h2> Gerador de Horários </h2>
            <p>
                Em construção.
            </p>
        </div>
        )
    }
}
export default BusSchedMetadata;
